/* ============================================================
   proart-animations.js
   Pro Art Cartridge — Animation controllers
   ============================================================ */

(function () {
  'use strict';

  /* ── PRO TEAM SCROLL (Homepage) ── */

  function initProTeamScroll() {
    var wrapper = document.querySelector('.proart-scroll-wrapper');
    if (!wrapper) return;

    var arrow = document.querySelector('.pts__scroll-arrow');
    var cards = wrapper.querySelectorAll('[data-pts-card]');
    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;
    var dragDistance = 0;

    wrapper.addEventListener('mousedown', function (e) {
      isDragging = true;
      dragDistance = 0;
      startX = e.pageX;
      scrollStart = wrapper.scrollLeft;
      wrapper.style.cursor = 'grabbing';
      wrapper.classList.add('is-dragging');
    });

    wrapper.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      var dx = e.pageX - startX;
      dragDistance = Math.abs(dx);
      wrapper.scrollLeft = scrollStart - dx * 1.2;
    });

    function stopDrag() {
      if (!isDragging) return;
      isDragging = false;
      wrapper.style.cursor = '';
      wrapper.classList.remove('is-dragging');
    }

    wrapper.addEventListener('mouseup', stopDrag);
    wrapper.addEventListener('mouseleave', stopDrag);

    wrapper.addEventListener('click', function (e) {
      if (dragDistance > 5) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    function checkArrow() {
      if (!arrow) return;
      var atEnd = wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth - 20;
      arrow.style.opacity = atEnd ? '0' : '';
      arrow.style.pointerEvents = atEnd ? 'none' : '';
    }

    wrapper.addEventListener('scroll', checkArrow, { passive: true });
    checkArrow();

    var section = document.querySelector('.pts');
    if (!section) return;

    cards.forEach(function (card) {
      card.style.opacity = '0';
      card.style.transform = 'translateX(40px)';
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cards.forEach(function (card, i) {
          setTimeout(function () {
            card.style.transition = 'opacity 600ms cubic-bezier(0.16,1,0.3,1), transform 600ms cubic-bezier(0.16,1,0.3,1)';
            card.style.opacity = '1';
            card.style.transform = 'translateX(0)';
          }, i * 80);
        });
        observer.disconnect();
      });
    }, { threshold: 0.1 });

    observer.observe(section);
  }

  /* ── PRO TEAM PAGE — Roster Cinématique ── */

  function initProTeamRoster() {
    var root = document.querySelector('[data-pro-team-roster]');
    if (!root) return;

    var navItems = root.querySelectorAll('.ptr__nav-item');
    var panels = root.querySelectorAll('.ptr__panel');
    /* Le roster est piloté par des blocs : le marchand peut tous les supprimer.
       Sans ce garde-fou, staggerIn(panels[0]) plante sur un tableau vide et
       emporte tout le reste du fichier d'animations avec lui. */
    if (!panels.length) return;
    var currentIndex = 0;
    var isTransitioning = false;

    /* Lock body scroll */
    if (window.innerWidth > 900) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    function staggerIn(panel) {
      var els = panel.querySelectorAll('[data-ptr-stagger]');
      var delays = [0, 80, 160, 220, 220, 300];
      els.forEach(function (el, i) {
        el.classList.remove('ptr-visible');
        var delay = i < delays.length ? delays[i] : 300;
        /* Extra stagger for individual tags */
        if (el.hasAttribute('data-ptr-stagger-tag')) {
          var tagParent = el.closest('[data-ptr-stagger]');
          if (tagParent) return; /* handled by parent */
        }
        setTimeout(function () {
          el.classList.add('ptr-visible');
        }, delay);
      });
      /* Stagger tags individually */
      var tags = panel.querySelectorAll('[data-ptr-stagger-tag]');
      tags.forEach(function (tag, i) {
        setTimeout(function () {
          tag.style.opacity = '1';
          tag.style.transform = 'translateY(0)';
        }, 300 + i * 40);
      });
    }

    function switchTo(index) {
      if (index === currentIndex || isTransitioning) return;
      if (index < 0 || index >= panels.length) return;
      isTransitioning = true;

      var outPanel = panels[currentIndex];
      var inPanel = panels[index];

      /* Update nav */
      navItems.forEach(function (item) { item.classList.remove('is-active'); });
      navItems[index].classList.add('is-active');

      /* Reset stagger on incoming */
      inPanel.querySelectorAll('[data-ptr-stagger]').forEach(function (el) {
        el.classList.remove('ptr-visible');
      });
      inPanel.querySelectorAll('[data-ptr-stagger-tag]').forEach(function (tag) {
        tag.style.opacity = '0';
        tag.style.transform = 'translateY(16px)';
        tag.style.transition = 'opacity 500ms cubic-bezier(0.16,1,0.3,1), transform 500ms cubic-bezier(0.16,1,0.3,1)';
      });

      /* Exit current */
      outPanel.classList.add('is-exiting');
      outPanel.classList.remove('is-active');

      /* Enter new after delay */
      setTimeout(function () {
        outPanel.classList.remove('is-exiting');
        inPanel.classList.add('is-active');
        staggerIn(inPanel);
        currentIndex = index;
        isTransitioning = false;
      }, 150);
    }

    /* Click nav */
    navItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var idx = parseInt(item.getAttribute('data-ptr-index'), 10);
        switchTo(idx);
      });
    });

    /* Keyboard navigation */
    document.addEventListener('keydown', function (e) {
      if (!root.closest('body')) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        switchTo(currentIndex + 1);
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault();
        switchTo(currentIndex - 1);
      }
    });

    /* Initial stagger on first panel */
    setTimeout(function () {
      staggerIn(panels[0]);
    }, 200);
  }

  /* ── CATALOGUE PAGE ── */

  function initCatalogue() {
    var filters = document.querySelectorAll('.pcat-filter');
    /* On ne filtre QUE les cartes porteuses d'un titre. Les cartes de la section
       soins ont data-pcat-card mais pas data-product-title : sans ce garde-fou,
       cliquer un filtre les masquait toutes définitivement. */
    var cards = document.querySelectorAll('[data-pcat-card][data-product-title]');
    var noResults = document.querySelector('[data-pcat-no-results]');
    if (!filters.length) return;

    /* Filters */
    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-filter');
        filters.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        var idx = 0;
        cards.forEach(function (card) {
          var title = card.getAttribute('data-product-title') || '';
          var show = filter === 'all' || title.toLowerCase().indexOf(filter.toLowerCase()) !== -1;

          if (show) {
            card.style.display = '';
            card.style.opacity = '0';
            card.style.transform = 'scale(0.98)';
            (function (i) {
              setTimeout(function () {
                card.style.transition = 'opacity 300ms ease, transform 300ms ease';
                card.style.opacity = '1';
                card.style.transform = 'scale(1)';
              }, i * 80);
            })(idx);
            idx++;
          } else {
            card.style.transition = 'opacity 300ms ease, transform 300ms ease';
            card.style.opacity = '0';
            card.style.transform = 'scale(0.98)';
            setTimeout(function () { card.style.display = 'none'; }, 300);
          }
        });

        /* Un filtre qui ne correspond à rien laissait une grille vide et muette. */
        if (noResults) noResults.hidden = idx > 0;
      });
    });

    /* Scroll reveal sections */
    var sections = document.querySelectorAll('[data-pcat-section]');
    sections.forEach(function (section) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var items = entry.target.querySelectorAll('[data-pcat-card], .pcat-featured, .pcat-guide__item');
          items.forEach(function (item, i) {
            item.style.opacity = '0';
            item.style.transform = 'translateY(24px)';
            setTimeout(function () {
              item.style.transition = 'opacity 600ms cubic-bezier(0.16,1,0.3,1), transform 600ms cubic-bezier(0.16,1,0.3,1)';
              item.style.opacity = '1';
              item.style.transform = 'translateY(0)';
            }, i * 80);
          });
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
      observer.observe(section);
    });
  }

  /* ── INIT ── */
  function init() {
    initProTeamScroll();
    initProTeamRoster();
    initCatalogue();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
